import { Space, Stack } from '@mantine/core';
import { useContext } from 'react';
import { DndProvider } from 'react-dnd-latest';
import { HTML5Backend } from 'react-dnd-html5-backend-latest';
import ContractTextBlock from '../../../../Organismns/Contract/ContractTemplateTextBlock';
import { ContractTemplateContext } from '../../../../Service/Context/ContractTemplateContext';
import ContractDocumentBlock from '../../../../Organismns/Contract/ContractTemplateDocumentBlock';
import { ContractTemplateBlockButtons } from '../../../../Organismns/Contract/AddBlockButtons';
import { RichInput } from '../../../../Organismns/tiptap/TiptapEditorInput';
import DocumentBubbleMenu from '../../../../Organismns/tiptap/toolbars/BubbleMenu';
import { TiptapS } from '../../../../Service/TiptapS';

const ContractTemplateContentSection = () => {
  const { template, savePatch, aboveBlocks, belowBlocks } = useContext(ContractTemplateContext);
  if (!template) {
    return null;
  }
  const { subject, positions } = template;
  const isEmpty = aboveBlocks.length === 0 && belowBlocks.length === 0;

  return (
    <>
      <RichInput
        label="Überschrift"
        value={subject}
        patchField={async (htmlString) => {
          const res = await savePatch({ subject: htmlString });
          return res !== null;
        }}
        menu={<DocumentBubbleMenu />}
        styles={TiptapS.TextInputStyles}
      />
      <Space h="xl" />
      <DndProvider backend={HTML5Backend}>
        <Stack spacing={5}>
          {aboveBlocks.map((textBlock, index) => (
            <ContractTextBlock key={textBlock.id} isAbove index={index} textBlock={textBlock} />
          ))}
          {positions && <ContractDocumentBlock />}
          {belowBlocks.map((textBlock, index) => (
            <ContractTextBlock key={textBlock.id} index={index} textBlock={textBlock} />
          ))}
        </Stack>
      </DndProvider>
      {isEmpty && <ContractTemplateBlockButtons isAbove withoutGap />}
    </>
  );
};

export default ContractTemplateContentSection;
